module.exports = __webpack_public_path__ + "static/media/sv-swiper1.53f1e903.png";